/* Street-only rendering for narrow rows: "714 Duchess St, Saskatoon, SK
 * S7K 0R3, Canada" → "714 Duchess St". Everything before the first comma
 * is the civic address; the rest (city / prov / postal / country) is noise
 * on a phone screen. */
export function shortAddress(addr) {
  const s = (addr || "").trim();
  if (!s) return "";
  const head = s.split(",")[0].trim();
  return head || s;
}
